export function findParent(element, compare) {
    let p = element
    while (p) {
        if (compare(p)) return p
        p = p.parentElement
    }
}
